import type { WorkspaceDoc } from '@/lib/sync/entity-types';

export type CanvasEmbedState = 'pending' | 'live' | 'archived' | 'deleted';

/**
 * Derive the embed's render state from the canvas's workspace row, with the
 * transient `pending` generation flag as a fallback when the row hasn't synced
 * yet.
 *
 * A synced row always wins (live/archived). With no row: `pending` while
 * generation is in flight, else `deleted`.
 */
export function resolveCanvasEmbedState(
  canvas: WorkspaceDoc | undefined,
  pending = false,
): CanvasEmbedState {
  if (canvas) return canvas.isArchived ? 'archived' : 'live';
  if (pending) return 'pending';
  return 'deleted';
}
